import { render, staticRenderFns } from "./DocumentRequestDeadlineDialog.vue?vue&type=template&id=2b4dd9e8&scoped=true&"
import script from "./DocumentRequestDeadlineDialog.vue?vue&type=script&lang=js&"
export * from "./DocumentRequestDeadlineDialog.vue?vue&type=script&lang=js&"
import style0 from "./DocumentRequestDeadlineDialog.vue?vue&type=style&index=0&id=2b4dd9e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4dd9e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCheckbox,VDialog,VIcon,VProgressLinear,VTextField,VTextarea})
